export default __webpack_public_path__ + "static/media/2-min.b69b73b1.jpg";